<span id="{{data}}" [translation]="TranslationEnum.Translation">
  {{data|translate}}
</span>
<mat-icon (click)="snackBarRef.dismiss()" class="float-right">close</mat-icon>
